// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2DJKN","label":"CategoryService_label__1Q65n","location":"CategoryService_location__tp40W"};